import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { CompanyStore, User } from "../../components/Store/types/storeType";
import { Employee } from "../../components/Employees/types/employees";

export interface StoreState {
  storeList: CompanyStore[];
  storeDetails?: CompanyStore;
  storeUsers: User[];
  storeSuppliers: string[]; // supplierIds
}

export const initialStoreState: StoreState = {
  storeList: [],
  storeUsers: [],
  storeSuppliers: []
};

export const storeSlice = createSlice({
  name: "storeSlice",
  initialState: initialStoreState,
  reducers: {
    // ----------------- Store List -----------------
    setStoreList: (state, action: PayloadAction<CompanyStore[]>) => {
      state.storeList = action.payload;
    },
    resetStoreList: (state) => {
      state.storeList = initialStoreState.storeList;
    },
    addStore: (state, action: PayloadAction<CompanyStore>) => {
      state.storeList.push(action.payload);
    },
    updateStore: (state, action: PayloadAction<CompanyStore>) => {
      state.storeList = state.storeList.map((store) =>
        store.id === action.payload.id ? action.payload : store
      );
      if (state.storeDetails?.id === action.payload.id) {
        state.storeDetails = action.payload;
      }
    },
    deleteStore: (state, action: PayloadAction<string>) => {
      state.storeList = state.storeList.filter(
        (store) => store.id !== action.payload
      );
      if (state.storeDetails?.id === action.payload) {
        state.storeDetails = undefined;
      }
    },

    // ----------------- Store Details -----------------
    setStoreDetails: (state, action: PayloadAction<CompanyStore>) => {
      state.storeDetails = action.payload;
    },
    resetStoreDetails: (state) => {
      state.storeDetails = initialStoreState.storeDetails;
    },
    addToStore: (state, action: PayloadAction<CompanyStore>) => {
      state.storeList.push(action.payload);
    },
    setStoreUsers: (state, action: PayloadAction<Employee[]>) => {
      state.storeUsers = action.payload;
    }
  }
});

// ----------------- Action creators -----------------
export const {
  setStoreList,
  resetStoreList,
  setStoreDetails,
  resetStoreDetails,
  addToStore,
  updateStore,
  setStoreUsers
} = storeSlice.actions;

export default storeSlice.reducer;
